module.exports = __webpack_public_path__ + "img/logo.b7278be0.png";